require("./heatmap/HeatmapSeries");

require("./heatmap/HeatmapView");